export interface IList {
	name?: string;
	content?: string;
	assignee?: number;
	status?: string;
	priority?: number;
	due_date?: number;
	due_date_time?: boolean;
	unset_status?: boolean;
}
